import { ref, computed, watch } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import ability from '@/libs/acl/ability'
import { debounce } from 'lodash'
import useFilterCounter from '@/components/Filters/useFiltersCount'

export default function useList() {
  const refListTable = ref(null)

  const toast = useToast()

  store.dispatch('unit/getAll', { with: 'router:id,id_tenant' });
  store.dispatch('center/getAll');
  store.dispatch('sector/getAll');

  const facilitiesOptions = computed(() => store.getters['unit/getSelectedItems']);
  const centerOptions = computed(() => store.getters['center/getSelectedItems']);
  const sectorOptions = computed(() => store.getters['sector/getSelectedItems']);

  const facilitiesFilter = ref(null);
  const centerFilter = ref(null);
  const sectorFilter = ref(null);


  const tableColumns = [
    { label: '', key: 'panel_status' },
    { label: '', key: 'active' },
    { label: 'intelbras.name', key: 'name', sortable: true },
    { label: 'intelbras.units', key: 'unit.description', sorteable: false },
    { label: 'intelbras.center', key: 'center.name', sorteable: false },
    { label: 'intelbras.sector', key: 'sector.name', sorteable: false },
    { label: 'intelbras.profile_name', key: 'profile.name', sortable: false },
    { label: 'intelbras.instance_host', key: 'instance_host', sorteable: false },
    { label: 'intelbras.panel_model', key: 'panel_model', sorteable: false },
    { label: 'intelbras.listening_port', key: 'panel_listening_port', sorteable: false },
    { label: 'intelbras.uuid', key: 'uuid', sorteable: false },
    { label: 'intelbras.client_password', key: 'client_password', sorteable: false },
    { label: 'intelbras.remote_control_password', key: 'remote_cfg_password', sorteable: false },
  ]

  if (ability.can('update', 'Intelbras') == true || ability.can('delete', 'Intelbras') == true) {
    tableColumns.splice(0, 0, { label: 'actions.name', key: 'actions' })
  }

  const perPage = ref(10)
  const totalList = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    }
  })

  const fetchList = (ctx, callback) => {
    store.dispatch('intelbras_panels/getAll', {
      q: searchQuery.value,
      max: perPage.value,
      'page[n]': currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      center: centerFilter.value,
      sector: sectorFilter.value,
      units: facilitiesFilter.value
    })
      .then(response => {
        callback(response.data)
        totalList.value = response.meta.total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error obteniendo la información',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }


  const refetchData = () => {
    refListTable.value.refresh()
  }

  watch([currentPage, perPage,], () => {
    refetchData()
  })

  watch([searchQuery], debounce(() => {
    refetchData()
  }, 500))

  // filters counter ============================
  const filters = ref({});
  const filtersCount = useFilterCounter(filters);
  const buildFilters = () => {
    filters.value = {
      q: searchQuery.value,
      center: centerFilter.value,
      sector: sectorFilter.value,
      units: facilitiesFilter.value
    }
    refetchData();
  }

  const clearSearchFilters = () => {
    searchQuery.value = null;
    centerFilter.value = null;
    sectorFilter.value = null;
    facilitiesFilter.value = null;

    buildFilters();
  }
  // ============================================

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    centerFilter,
    sectorFilter,
    facilitiesFilter,
    facilitiesOptions,
    centerOptions,
    sectorOptions,

    refetchData,

    filtersCount,
    buildFilters,
    clearSearchFilters,
  }
}
